import { cn } from '@/lib/utils';
import { passwordRules } from '../lib/password';

/* Live strong-password criteria checklist (EDU-61). Shown under password fields
   during sign-up / password reset. */
export default function PasswordChecklist({ password }: { password: string }) {
  return (
    <ul className="list-none mt-2 p-0 flex flex-col gap-0.5">
      {passwordRules(password).map((r) => (
        <li key={r.key} className={cn("text-[12.5px] font-bold text-muted-foreground flex items-center gap-[6px]", r.ok && "text-foreground")}>
          <span aria-hidden>{r.ok ? '✅' : '⚪️'}</span> {r.label}
        </li>
      ))}
    </ul>
  );
}
